// src/layouts/FleetLayout.jsx
import { AppShell, Container, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopNavbar from '../components/TopNavbar';

export default function FleetLayout() {
  const [opened, { toggle, close }] = useDisclosure();

  return (
    <AppShell
      header={{ height: 65 }}
      navbar={{
        width: 240,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
      bg="gray.0"
    >
      <AppShell.Header>
        {/* Sidebar olduğu için toggle ve opened proplarını gönderiyoruz (Mobilde hamburger menü çıkması için) */}
        <TopNavbar 
          opened={opened} 
          toggle={toggle} 
          showBackButton={true} 
          title="Grup" 
          highlight="Filo" 
        />
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Text c="dimmed" size="xs" fw={700} mb="sm" tt="uppercase" ls={1}>
          Filo Yönetimi
        </Text>
        <Sidebar onClose={close} />
      </AppShell.Navbar>

      <AppShell.Main>
        <Container fluid px={0}>
            <Outlet /> 
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}